import request from "@/utils/request";

// 运营商保存个人收款用户信息
export default function agentFillInInformation(data) {
  return request({
    url: `/user/agent/agent/fillInInformation`,
    method: "post",
    data,
  });
}
